import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { OrderformIframeService } from '../../services/orderform-iframe.service';

@Component({
  selector: 'orderform-iframe-modal',
  templateUrl: './iframe-modal.component.html',
  styleUrls: ['./iframe-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeModalComponent {
  @Input() public label: string;
  @Input() public url: string;
  @Input() public downloadURL?: string;
  private _open = false;
  @Input() public get modalVisible(): boolean {
    return this._open;
  }
  set modalVisible(v: boolean) {
    if (this._open !== v && !v) {
      this.close.emit();
    }
    this._open = v;
  }

  @Output() public readonly close = new EventEmitter<void>();

  public usedInIframe = this.orderformIframeService.iframeActive;
  public scrollPosition$ = this.orderformIframeService.scrollPosition$;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private orderformIframeService: OrderformIframeService
  ) {}

  /**
   * @param label
   * @param url
   */
  openModal(label: string, url: string) {
    this.orderformIframeService.ds24_sendScrollPosition();
    this.label = label;
    this.url = url;
    this.modalVisible = true;

    if (
      ['/terms', '/privacy', '/cancellation'].find((key) =>
        this.url.includes(key)
      )
    ) {
      this.downloadURL = this.url.replace(`page/popup`, `download`);
      this.downloadURL = this.downloadURL.replace(
        `download/legal`,
        `download/reseller`
      );
    } else {
      this.downloadURL = null;
    }

    // We want to keep onPush Strategy so we need to detect the change ourselves
    this.cdRef.detectChanges();
  }

  closeModal() {
    this.modalVisible = false;
    this.close.emit();
  }

  download() {
    if (this.downloadURL) {
      window.open(this.downloadURL, '_blank');
    }
  }
}
